export enum Gender {
    FEMALE = 'f',
    MALE = 'm',
    INTER = 'd',
}
